export const list = {
    listStyleType: 'none',
    margin: '0',
    padding: '0',
}

export const container = {
    borderRight: '1px solid $menubarBorder',
    left: 0,
    marginRight: '-1px',
    padding: '10px',
    position: 'sticky',
    top: 0,
    zIndex: '$sideMenu',
}

export const dropdownsButtonsWrapper = {'> *': {width: '100%'}}
